import aboImage2 from "web/assets/images/abo_podst_baner2.png";
import aboImage from "web/assets/images/abo_podst_baner.png";

import { ISubscriptionConfigWithEmployeeSettings } from "web/types/Subscription";

export default (
  config: ISubscriptionConfigWithEmployeeSettings,
) => {
  if (config) {
    const selectionWindowData = [
      {
        group: 1,
        image: aboImage,
        isWindowOpen: config.open,
        isGroupAvailable: config.configuratorWindowOpen,
        showOnListing: config.showSubscriptionsInListing === "1",
        chooseSubscriptionsTo: config.chooseSubscriptionsTo,
        startSubscriptionsFrom: config.startSubscriptionsFrom,
      },
      {
        group: 2,
        image: aboImage2,
        isWindowOpen: config.openUms,
        isGroupAvailable: config.configuratorWindowOpenUms,
        showOnListing: config.showSubscriptionsInListingUMS === "1" ,
        chooseSubscriptionsTo: config.chooseUmsSubscriptionsTo,
        startSubscriptionsFrom: config.startUmsSubscriptionsFrom,
      },
    ];

    return selectionWindowData;
  }

  return null;
};
